import getAssetUrl from 'utils/getAssetUrl';

// Purely decorative — carries no translatable text, so it stays out of i18n.
export const teamBuildingCarousel = [
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_1.jpg') },
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_2.jpg') },
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_3.jpg') },
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_4.jpg') },
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_5.jpg') },
  { imageUrl: getAssetUrl('/assets/carousel/FOTO_6.jpg') },
];

export const officeTripsImage = getAssetUrl('/assets/carousel/FOTO_1.jpg');
